import React from "react";
import { Link } from "react-router-dom";
import { UpcomingData } from "../Components/upcomingData";
class Upcoming extends React.Component {
  state = { added: false, id: null };
  render() {
    return (
      <div>
        <div className="products">
          {UpcomingData.map((e, index) => {
            return (
              <div key={index} className="product-card">
                <span className="badge">{e.bestSeller && "Best Seller"}</span>
                <img src={e.img} alt="" />
                <h3>
                  {e.name} <Link to={`/upcoming/${e.id}`}>more info</Link>
                </h3>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star gold"></i>
                <i className="fa fa-star-half half-star" aria-hidden="true"></i>
                <span className="card-items">
                  <Link
                    to="/payments"
                    className="btn btn-buy"
                    onClick={() =>
                      this.props.setTotal(e.price * 0.8 + e.delivery, e.id)
                    }
                  >
                    Buy
                  </Link>
                  <Link to="/wishlist">
                    <i
                      className="fa fa-light fa-heart"
                      onClick={() => this.props.handleWishlist(e)}
                    ></i>
                  </Link>
                  <button
                    className="btn btn-add-to-cart"
                    onClick={() => {
                      this.props.handleCart(e);
                      this.setState({ added: true, id: e.id });
                    }}
                  >
                    {this.state.added && this.state.id === e.id
                      ? "Added"
                      : "Add to cart"}
                  </button>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
export default Upcoming;
